import React from 'react';
import { SponsorMetadata } from '../../types/sponsor';
import { Link } from 'lucide-react';

interface SponsorDisplayProps {
  sponsor: SponsorMetadata;
  className?: string;
}

export function SponsorDisplay({ sponsor, className = '' }: SponsorDisplayProps) {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <img
        src={sponsor.logo_url}
        alt={`${sponsor.name} logo`}
        className="h-8 w-auto object-contain"
      />
      <div className="flex flex-col">
        <div className="font-medium text-gray-900">{sponsor.name}</div>
        {sponsor.website && (
          <a
            href={sponsor.website}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1"
          >
            <Link className="w-3 h-3" />
            Visit Website
          </a>
        )}
      </div>
    </div>
  );
}